var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graduation-hat-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.33398 6.66704V10.6745C3.33398 10.9138 3.33398 11.0334 3.37042 11.1391C3.40264 11.2325 3.45523 11.3176 3.52437 11.3882C3.60256 11.468 3.70959 11.5215 3.92362 11.6285L7.52362 13.4285C7.69853 13.516 7.78599 13.5597 7.87772 13.5769C7.95897 13.5922 8.04234 13.5922 8.12358 13.5769C8.21531 13.5597 8.30278 13.516 8.47768 13.4285L12.0777 11.6285C12.2917 11.5215 12.3987 11.468 12.4769 11.3882C12.5461 11.3176 12.5987 11.2325 12.6309 11.1391C12.6673 11.0334 12.6673 10.9138 12.6673 10.6745V6.66704M1.33398 5.66704L7.76214 2.45296C7.84959 2.40923 7.89332 2.38737 7.93919 2.37876C7.97981 2.37114 8.02149 2.37114 8.06212 2.37876C8.10798 2.38737 8.15171 2.40923 8.23917 2.45296L14.6673 5.66704L8.23917 8.88111C8.15171 8.92484 8.10798 8.9467 8.06212 8.95531C8.02149 8.96293 7.97981 8.96293 7.93919 8.95531C7.89332 8.9467 7.84959 8.92484 7.76214 8.88111L1.33398 5.66704Z",
    stroke: "#01588C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.f841f2da2a2945546542e445d37ea2de.svg";
export { ForwardRef as ReactComponent };